import script from "./Job.vue?vue&type=script&setup=true&lang=js"
export * from "./Job.vue?vue&type=script&setup=true&lang=js"

import "./Job.vue?vue&type=style&index=0&id=1a644720&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a644720"]])

export default __exports__